import { render, staticRenderFns } from "./SubscrConstructorSection.vue?vue&type=template&id=5c31c7a6&scoped=true"
import script from "./SubscrConstructorSection.vue?vue&type=script&lang=js"
export * from "./SubscrConstructorSection.vue?vue&type=script&lang=js"
import style0 from "./SubscrConstructorSection.vue?vue&type=style&index=0&id=5c31c7a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c31c7a6",
  null
  
)

export default component.exports